import { render, staticRenderFns } from "./doorManagement.vue?vue&type=template&id=53b0c035&scoped=true"
import script from "./doorManagement.vue?vue&type=script&lang=js"
export * from "./doorManagement.vue?vue&type=script&lang=js"
import style0 from "./doorManagement.vue?vue&type=style&index=0&id=53b0c035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b0c035",
  null
  
)

export default component.exports